import './tooltip.scss';
import * as React from 'react';

interface ITooltipProps {
    title: string;
    children: JSX.Element;
    placement?: string;
}
export const Tooltip = (props: ITooltipProps) => {
    const { children, title, placement = 'bottom' } = props;
    const renderTip = () => {
        return (
            <div className={`umu-design-comp-tooltip umu-design-comp-tooltip-placement-${placement}`}>
                <div className="umu-design-comp-tooltip-content">
                    <div className="umu-design-comp-tooltip-arrow">
                        <span className="umu-design-comp-tooltip-arrow-content"></span>
                    </div>
                    <div className="umu-design-comp-tooltip-inner" role="tooltip">
                        {title}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="tooltip-wrap">
            {renderTip()}
            {children}
        </div>
    );
};
